import withComposedClassName from '../../../../../composables/withComposedClassName'
import styles from './PrequalTabFooter.module.scss'

export default withComposedClassName(styles.root)('div')
